import { useAppSelector } from '@store';
import useCompanyOfficial from '../hooks/use-company-official';
import { CompanyOfficialItemTypes } from '../types';
import CompanyOfficialItemContent from '../../../../components/corporate/overview/company-official-item';

const CompanyOfficialItem = ({
  value,
  list,
  removed,
}: CompanyOfficialItemTypes) => {
  const { activePermissions } = useAppSelector((state) => state.root);

  const {
    formValues,
    updateStatusInProgress,
    employeeName,
    approveInProgress,
    defaultFormValues,
    cofIsUpdate,
    onApprove,
    setFormValues,
    updateCofAction,
    setPopupIsVisible,
    setRejectReason,
    onUpdateCofStatus,
    popupIsVisible,
    rejectReason,
  } = useCompanyOfficial({
    value,
    list,
    removed,
  });

  return (
    <CompanyOfficialItemContent
      value={value}
      removed={removed}
      activePermissions={activePermissions}
      formValues={formValues}
      updateStatusInProgress={updateStatusInProgress}
      employeeName={employeeName}
      approveInProgress={approveInProgress}
      defaultFormValues={defaultFormValues}
      cofIsUpdate={cofIsUpdate}
      onApprove={onApprove}
      setFormValues={setFormValues}
      updateCofAction={updateCofAction}
      setPopupIsVisible={setPopupIsVisible}
      setRejectReason={setRejectReason}
      onUpdateCofStatus={onUpdateCofStatus}
      popupIsVisible={popupIsVisible}
      rejectReason={rejectReason}
    />
  );
};

export default CompanyOfficialItem;
